export enum AvatarSortingTypes {
    'Suits' = 1
    , 'Sportcoats'
    , 'Shirt/Pants'
    , 'Safaris'
    , 'Bombers'
    , 'Overshirts'
    // , 'Sweaters'
    , 'Outerwear'
    , 'Ultra Casual'
    // , 'Shoes'
    , 'Formal/Tuxedos'
    , 'Leather Jackets'
    , 'Sweaters'
}
